import {
    Badge,
    Box,
    Button,
    Card,
    Container,
    Group,
    LoadingOverlay,
    Modal,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Tabs,
    Text,
    TextInput,
} from '@mantine/core';
import { getUserVerticals, getVerticals } from '../../../../../http/apiClient';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SearchableSelect } from '../../../../common';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { hasRole } from '../../../../../utils/roles';
import { useAuthStore } from '../../../../../store';
import { useEffect } from 'react';

const EmailCampaignSubview = ({ form, campaign }) => {
    useEffect(() => {}, [campaign]);
    const userProfile = useAuthStore((state) => state.userProfile);
    //const { isPending, mutate: addOrUpdate } = useAddMessageGroup();
    const userQueryHttpFn = (queryHttpFn, queryParams) => {
        const userId = form.values.userId;
        const searchUserRoutes = hasRole(userProfile, 'SUPER_ADMIN') && userId;

        if (searchUserRoutes) {
            return queryHttpFn({
                userId,
                type: 'email',
                pagination: queryParams,
            });
        }
        return queryHttpFn({
            type: 'email',
            pagination: queryParams,
        });
    };

    return (
        <>
            <SearchableSelect
                label={'Route'}
                withAsterisk
                placeholder='Select sending route'
                queryHttpFn={(queryParams) =>
                    userQueryHttpFn(getUserRoutes, queryParams)
                }
                queryKey={
                    form.values.userId
                        ? ['user_routes', 'email', form.values.userId]
                        : ['user_routes', 'email']
                }
                optionsMapFn={(route) => ({
                    label: route.name,
                    value: route.id.toString(),
                })}
                defaultValue={campaign?.route}
                {...form.getInputProps('routeId')}
            />
        </>
    );
};
export default EmailCampaignSubview;
